const Fight_Hard = () => {
  return (
    <>
      <div className="py-12 bg-gray-200">
        <div className="flex flex-wrap justify-center -mx-4 container mx-auto">
          <div className="w-full px-4 text-center">
            <span className="inline-block px-3 py-1 mb-2 text-xs font-bold uppercase leading-tight text-pink-500 bg-pink-200 rounded-full mr-1">
              Fight hard
            </span>
            <h2 className="mt-3 mb-1 text-4xl font-bold from-[#a200be] to-[#246BFD] bg-gradient-to-tl bg-clip-text text-transparent">
              It's time to know
            </h2>
            <p className="mt-2 mb-4 text-xl px-6 leading-relaxed text-gray-500">
              Go and show them how strong you are. Leave them with their jaws to
              the ground, and hit them so that they faint on the ropes. Since
              you've got talent, you have to wear a crown.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-start  px-10 container mx-auto">
          <div className="w-full px-4 lg:w-4/12 text-left">
            <div className="flex items-center justify-center w-16 h-16 mb-2 text-blue-500 bg-white border border-blue-500 rounded-full shadow-lg">
              <i className="fas fa-cog text-lg"></i>
            </div>
            <h6 className="mt-6 mb-2 text-xl font-semibold leading-tight">
              Social Conversation
            </h6>
            <p className="mb-2 text-gray-500">
              We get insulted by others, lose trust for those others. We get
              back stabbed by friends. It becomes harder for us to give others a
              hand.
            </p>
            <a href="javascript:;" className="text-blue-500 hover:underline">
              More about us <i className="ml-1 fas fa-angle-right"></i>
            </a>
          </div>

          <div className="w-full px-4 lg:w-4/12 text-left">
            <div className="flex items-center justify-center w-16 h-16 mb-2 text-emerald-500 bg-white border border-emerald-500 rounded-full shadow-lg">
              <i className="fas fa-atom text-lg"></i>
            </div>
            <h6 className="mt-6 mb-2 text-xl font-semibold leading-tight">
              Analyze Performance
            </h6>
            <p className="mb-2 text-gray-500">
              Don't get your heart broken by people we love, even that we give
              them all we have. Then we lose family over time. As we live, our
              hearts turn colder.
            </p>
            <a href="javascript:;" className="text-blue-500 hover:underline">
              Learn about our products{" "}
              <i className="ml-1 fas fa-angle-right"></i>
            </a>
          </div>

          <div className="w-full px-4 lg:w-4/12 text-left">
            <div className="flex items-center justify-center w-16 h-16 mb-2 text-orange-500 bg-white border border-orange-500 rounded-full shadow-lg">
              <i className="fas fa-globe-europe text-lg"></i>
            </div>
            <h6 className="mt-6 mb-2 text-xl font-semibold leading-tight">
              Measure Conversions
            </h6>
            <p className="mb-2 text-gray-500">
              What else could rust the heart more over time? Blackgold. The time
              is now for it to be okay to be great. or being a bright color. For
              standing out.
            </p>
            <a href="javascript:;" className="text-blue-500 hover:underline">
              Check our documentation{" "}
              <i className="ml-1 fas fa-angle-right"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default Fight_Hard;
